import { render, staticRenderFns } from "./ExternalContainer.vue?vue&type=template&id=967bd3bc&"
import script from "./ExternalContainer.vue?vue&type=script&lang=js&"
export * from "./ExternalContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports